import { Box, Flex, Text, Textarea } from "@chakra-ui/react";
import PrimaryButton from "components/Buttons/PrimaryButton";
import { t } from "i18next";
import { useMemo } from "react";
import { useEmployeeStore } from "store/employeeStore";

const CourseEmployeeInfo = ({
  handleFirstBtn,
  textFirstBtn,
  isSelectedAll,
  error,
  isRequired = false,
}) => {
  const { allEmployees, selectedEmployeeIds } = useEmployeeStore();

  const textEmployeeValue = useMemo(() => {
    let textAll = t("pages.course_form.all_people");

    if (isSelectedAll && selectedEmployeeIds.length === allEmployees.length) {
      return textAll;
    }

    if (isSelectedAll) {
      const selectedIdsSet = new Set(selectedEmployeeIds);
      const exceptionList = allEmployees.filter(
        (employee) => !selectedIdsSet.has(employee.id)
      );

      if (exceptionList.length > 0) {
        textAll += `     -${exceptionList.map((i) => i.name).join(", ")}`;
        return textAll;
      }
    }

    const selectedIdsSet = new Set(selectedEmployeeIds);
    const result = allEmployees
      .filter((i) => selectedIdsSet.has(i.id))
      .map((i) => i.name)
      .join(", ");

    return result;
  }, [isSelectedAll, selectedEmployeeIds, allEmployees]);

  return (
    <>
      <Flex gap={"10px"} mb={"10px"}>
        <Box w={"15%"} mt={"8px"}>
          <Text fontSize={"14px"}>
            {t("pages.course_form.label.employees")}
            {isRequired && <Text as="span" color="red.500"> *</Text>}
          </Text>
        </Box>
        <Box width={"50%"}>
          <Textarea
            name="employees"
            minHeight={"158px"}
            disabled={false}
            isReadOnly={true}
            fontSize={"14px"}
            value={textEmployeeValue}
            borderColor={error ? "red.300" : "gray.300"}
            borderWidth="1px"
            _focus={{
              borderColor: error ? "red.300" : "blue.500",
              boxShadow: error ? "0 0 0 1px red.300" : "0 0 0 1px blue.500",
            }}
          />
          {error && (
            <Text color="red.500" fontSize="12px" mt={1}>
              {error}
            </Text>
          )}
        </Box>
        <Box mt={"8px"}>
          <PrimaryButton text={textFirstBtn} onClick={handleFirstBtn} />
        </Box>
      </Flex>
    </>
  );
};

export default CourseEmployeeInfo;
